import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";


import ScrollToTop from "../../../components/scroll-to-top";

export default function Return(){
    return(
        <>
        <Navbar navClass="defaultscroll is-sticky"/>
        <section className="relative table w-full py-32 lg:py-40 bg-gray-50 dark:bg-slate-800">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-10">
                    <h3 className="text-3xl leading-normal font-semibold">Return Policy</h3>
                    <p3>Learn how we collect, use, and protect your personal information with our detailed return policy.</p3>
                </div>
            </div>
            
            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="/">Sportyfi</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="">Policies</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold text-orange-500" aria-current="page">Return & Exchange Policy</li>
                </ul>
            </div>
        </section>

         <div className="p-6 md:p-10 max-w-4xl mx-auto  shadow text-gray-800 leading-relaxed">
      

    

      <h4 className="text-xl font-medium mb-2">1.1 Eligibility:</h4>
      <ul className="list-disc ml-6 mb-4">
        <li>Returns are accepted within <strong>1 day</strong> from the date of delivery.</li>
        <li>Items must be in their original condition, unused, and with all original packaging and tags intact.</li>
        <li>Certain products are non-returnable, including personalized or custom-made items.</li>
      </ul>

      <h4 className="text-xl font-medium mb-2">1.2 How to Return:</h4>
      <ul className="list-disc ml-6 mb-4">
        <li>Contact our customer support team at <strong>sportyfi@gmail.com</strong> to initiate a return.</li>
        <li>Provide your order number, details of the item(s) you wish to return, and the reason for the return.</li>
        <li>Our team will provide you with instructions on how to return the item(s) and a return authorization if applicable.</li>
        <li>Return pickup will be scheduled within <strong>3 to 7 business days</strong> after your return request is approved.</li>
      </ul>

      <h4 className="text-xl font-medium mb-2">1.3 Return Shipping:</h4>
      <ul className="list-disc ml-6 mb-4">
        <li>Customers are responsible for the cost of return shipping unless the return is due to a mistake on our part (e.g., incorrect or defective items).</li>
        <li>We recommend using a trackable shipping service or purchasing shipping insurance for returns. We are not responsible for items lost or damaged in transit.</li>
        <li>Exchanged products will be delivered within <strong>7–10 business days</strong>.</li>
      </ul>
    </div>
        <Footer/>
        <Switcher/>
        <ScrollToTop/>
        </>
    )
}